var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 210,
    viewBox: "0 0 488 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 480,
    height: 200,
    rx: 20,
    fill: "#CDE1FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 200,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.218 113V103.2H33.472V109.584L38.148 103.2H40.276V113H38.036V106.63L33.36 113H31.218ZM42.688 113V105.468H44.858V108.408H48.134V105.468H50.318V113H48.134V110.186H44.858V113H42.688ZM52.5488 113V105.468H54.7188V108.408H57.9948V105.468H60.1788V113H57.9948V110.186H54.7188V113H52.5488ZM66.9175 113V111.53L66.7775 111.208V108.576C66.7775 108.109 66.6328 107.745 66.3435 107.484C66.0635 107.223 65.6295 107.092 65.0415 107.092C64.6401 107.092 64.2435 107.157 63.8515 107.288C63.4688 107.409 63.1421 107.577 62.8715 107.792L62.0875 106.266C62.4981 105.977 62.9928 105.753 63.5715 105.594C64.1501 105.435 64.7381 105.356 65.3355 105.356C66.4835 105.356 67.3748 105.627 68.0095 106.168C68.6441 106.709 68.9615 107.554 68.9615 108.702V113H66.9175ZM64.6215 113.112C64.0335 113.112 63.5295 113.014 63.1095 112.818C62.6895 112.613 62.3675 112.337 62.1435 111.992C61.9195 111.647 61.8075 111.259 61.8075 110.83C61.8075 110.382 61.9148 109.99 62.1295 109.654C62.3535 109.318 62.7035 109.057 63.1795 108.87C63.6555 108.674 64.2761 108.576 65.0415 108.576H67.0435V109.85H65.2795C64.7661 109.85 64.4115 109.934 64.2155 110.102C64.0288 110.27 63.9355 110.48 63.9355 110.732C63.9355 111.012 64.0428 111.236 64.2575 111.404C64.4815 111.563 64.7848 111.642 65.1675 111.642C65.5315 111.642 65.8581 111.558 66.1475 111.39C66.4368 111.213 66.6468 110.956 66.7775 110.62L67.1135 111.628C66.9548 112.113 66.6655 112.482 66.2455 112.734C65.8255 112.986 65.2841 113.112 64.6215 113.112ZM31.218 133V123.2H33.094L37.266 130.116H36.272L40.374 123.2H42.25L42.264 133H40.136L40.122 126.462H40.528L37.238 131.964H36.23L32.87 126.462H33.346V133H31.218ZM48.3525 133.112C47.4938 133.112 46.7378 132.944 46.0845 132.608C45.4405 132.272 44.9411 131.815 44.5865 131.236C44.2318 130.648 44.0545 129.981 44.0545 129.234C44.0545 128.478 44.2271 127.811 44.5725 127.232C44.9271 126.644 45.4078 126.187 46.0145 125.86C46.6211 125.524 47.3071 125.356 48.0725 125.356C48.8098 125.356 49.4725 125.515 50.0605 125.832C50.6578 126.14 51.1291 126.588 51.4745 127.176C51.8198 127.755 51.9925 128.45 51.9925 129.262C51.9925 129.346 51.9878 129.444 51.9785 129.556C51.9691 129.659 51.9598 129.757 51.9505 129.85H45.8325V128.576H50.8025L49.9625 128.954C49.9625 128.562 49.8831 128.221 49.7245 127.932C49.5658 127.643 49.3465 127.419 49.0665 127.26C48.7865 127.092 48.4598 127.008 48.0865 127.008C47.7131 127.008 47.3818 127.092 47.0925 127.26C46.8125 127.419 46.5931 127.647 46.4345 127.946C46.2758 128.235 46.1965 128.581 46.1965 128.982V129.318C46.1965 129.729 46.2851 130.093 46.4625 130.41C46.6491 130.718 46.9058 130.956 47.2325 131.124C47.5685 131.283 47.9605 131.362 48.4085 131.362C48.8098 131.362 49.1598 131.301 49.4585 131.18C49.7665 131.059 50.0465 130.877 50.2985 130.634L51.4605 131.894C51.1151 132.286 50.6811 132.589 50.1585 132.804C49.6358 133.009 49.0338 133.112 48.3525 133.112ZM62.6595 133L60.6575 129.43L62.4215 128.38L65.2495 133H62.6595ZM59.3695 130.144V128.394H61.9875V130.144H59.3695ZM62.6455 129.486L60.5875 129.262L62.7575 125.468H65.0675L62.6455 129.486ZM55.2115 133H52.6355L55.4495 128.38L57.2135 129.43L55.2115 133ZM60.0135 133H57.8575V125.468H60.0135V133ZM58.5015 130.144H55.8975V128.394H58.5015V130.144ZM55.2255 129.486L52.8035 125.468H55.1135L57.2695 129.262L55.2255 129.486ZM66.5247 133V125.468H68.6947V129.948L72.3627 125.468H74.3647V133H72.1947V128.52L68.5407 133H66.5247ZM76.6041 133V125.468H78.7741V128.408H82.0501V125.468H84.2341V133H82.0501V130.186H78.7741V133H76.6041ZM90.9728 133V131.53L90.8328 131.208V128.576C90.8328 128.109 90.6882 127.745 90.3988 127.484C90.1188 127.223 89.6848 127.092 89.0968 127.092C88.6955 127.092 88.2988 127.157 87.9068 127.288C87.5242 127.409 87.1975 127.577 86.9268 127.792L86.1428 126.266C86.5535 125.977 87.0482 125.753 87.6268 125.594C88.2055 125.435 88.7935 125.356 89.3908 125.356C90.5388 125.356 91.4302 125.627 92.0648 126.168C92.6995 126.709 93.0168 127.554 93.0168 128.702V133H90.9728ZM88.6768 133.112C88.0888 133.112 87.5848 133.014 87.1648 132.818C86.7448 132.613 86.4228 132.337 86.1988 131.992C85.9748 131.647 85.8628 131.259 85.8628 130.83C85.8628 130.382 85.9702 129.99 86.1848 129.654C86.4088 129.318 86.7588 129.057 87.2348 128.87C87.7108 128.674 88.3315 128.576 89.0968 128.576H91.0988V129.85H89.3348C88.8215 129.85 88.4668 129.934 88.2708 130.102C88.0842 130.27 87.9908 130.48 87.9908 130.732C87.9908 131.012 88.0982 131.236 88.3128 131.404C88.5368 131.563 88.8402 131.642 89.2228 131.642C89.5868 131.642 89.9135 131.558 90.2028 131.39C90.4922 131.213 90.7022 130.956 90.8328 130.62L91.1688 131.628C91.0102 132.113 90.7208 132.482 90.3008 132.734C89.8808 132.986 89.3395 133.112 88.6768 133.112Z",
    fill: "#7872B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8495 38.7911C87.9871 43.2351 92.0719 62.4125 86.9219 75.5044C81.7719 88.5963 62.8059 92.3196 47.6763 87.8436C32.5467 83.3675 28.0855 68.2098 33.2595 55.1259C38.4335 42.042 57.72 34.347 72.8495 38.7911Z",
    fill: "#CDE1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4721 76.7534L37.2227 81.6619C39.273 85.081 43.8063 87.347 49.1165 88.6122C58.6235 90.8782 70.0448 90.566 78.4866 85.153L82.7556 82.0462L82.8757 81.9181L83.092 81.6619C82.5794 80.725 82.291 78.2988 81.8345 77.0417C81.3589 75.7166 80.4898 74.5684 79.3436 73.7507C77.1443 72.033 74.7187 70.6265 72.1352 69.5709L68.7313 68.0815C69.1958 70.6759 68.1546 73.0541 65.4555 73.1502C62.452 73.2623 61.1705 70.8681 60.1373 69.8912C59.6407 70.3556 59.6407 70.5238 59.0961 71.0843C55.0434 75.224 50.6383 72.6857 51.5433 68.0896C48.9872 69.0844 46.5014 70.2507 44.1026 71.5807C42.9418 72.2322 41.8426 72.988 40.8188 73.8388C39.912 74.7031 39.123 75.6831 38.4721 76.7534Z",
    fill: "#FAA8B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2337 44.8765C47.1692 44.7584 48.0622 44.4156 48.8363 43.8774C49.6104 43.3391 50.2427 42.6214 50.6789 41.7857C50.9912 42.3782 50.8791 43.4352 51.8242 44.1879C53.7224 45.6692 57.695 44.2439 59.425 42.154C59.2969 44.6443 59.425 46.4379 61.1551 47.3507C63.678 48.712 64.519 46.6461 66.6334 46.6461C70.3578 46.6461 70.8223 53.9407 65.7124 54.3491V64.9988C67.138 65.5993 67.9309 66.7604 68.7238 68.1056L72.1278 69.5949C72.5042 68.5059 74.6027 64.5584 75.8521 61.0592C79.4163 51.0661 79.6085 40.0161 71.5752 33.4181C66.9057 29.5826 58.4399 28.926 52.2807 31.6966C47.8916 33.6503 39.8183 40.993 46.2337 44.8765Z",
    fill: "#645F9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2345 44.8765C46.2345 46.6461 46.0022 48.5038 46.0343 50.4015C46.0663 52.2993 46.4027 53.9007 46.5469 55.6944C47.4039 57.8003 47.3478 59.1375 48.8455 60.787C50.3433 62.4365 51.6808 63.045 54.6042 62.6607C56.0886 62.4062 57.5431 62.0011 58.9453 61.4516C59.9144 61.0752 61.9648 59.9062 62.5335 59.77C61.9007 60.3225 60.6753 64.198 54.6042 64.4543V64.9908C54.7804 67.0567 54.6923 67.393 56.2942 68.1456C57.5095 68.727 58.8395 69.0287 60.1867 69.0287C61.5339 69.0287 62.864 68.727 64.0793 68.1456C65.7212 67.3449 65.561 67.0406 65.7612 64.9427V54.2931C70.8712 53.8847 70.4066 46.5821 66.6823 46.5901C64.5678 46.5901 63.7268 48.6559 61.2039 47.2947C59.514 46.3819 59.3458 44.5883 59.4739 42.098C57.7439 44.1879 53.7713 45.6132 51.8731 44.1319C50.928 43.4032 51.0721 42.3462 50.7277 41.7297C50.2939 42.5821 49.6573 43.3148 48.8738 43.8635C48.0903 44.4122 47.184 44.7601 46.2345 44.8765Z",
    fill: "#FDD3D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4732 76.7535C39.1414 75.6798 39.9494 74.6997 40.876 73.8388C41.8998 72.9881 42.9989 72.2323 44.1598 71.5808C46.5585 70.2508 49.0444 69.0844 51.6004 68.0896C52.2812 66.9366 53.3384 65.4072 54.6199 64.9908V64.4543V62.6607C51.6965 63.0451 50.2789 62.3805 48.8612 60.787C47.4436 59.1936 47.4196 57.8003 46.5626 55.6944C46.066 56.7514 43.2227 58.617 41.8931 59.618C38.337 62.3084 35.6219 65.5914 36.0383 70.692C36.1905 72.7258 37.2157 75.6965 38.4732 76.7535Z",
    fill: "#645F9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5687 68.0896C50.6636 72.7018 55.0687 75.2241 59.1215 71.0843C59.6661 70.5238 59.6661 70.3557 60.1627 69.8912C61.1959 70.8681 62.4774 73.2623 65.4808 73.1502C68.18 73.0541 69.2212 70.6759 68.7566 68.0816C67.9557 66.7364 67.1548 65.5753 65.7451 64.9748C65.5449 67.0567 65.7051 67.377 64.0632 68.1777C62.848 68.759 61.5179 69.0608 60.1707 69.0608C58.8235 69.0608 57.4934 68.759 56.2781 68.1777C54.6763 67.441 54.7644 67.0887 54.5882 65.0228C53.2907 65.3912 52.2495 66.9366 51.5687 68.0896Z",
    fill: "#6B66A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6016 62.6606V64.4543C60.6726 64.198 61.898 60.3225 62.5308 59.77C61.9621 59.9061 59.9117 61.0752 58.9426 61.4515C57.5405 62.001 56.0859 62.4062 54.6016 62.6606Z",
    fill: "#E8B7B8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 146,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 166,
    width: 60,
    height: 10,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 30,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 30,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FA788C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 30,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 80,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 80,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 80,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FA788C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 30,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 80,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 130,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FA788C"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 130,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 130,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FA788C"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 130,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 30,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FA788C"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 80,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 30,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 80,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FA788C"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 130,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 130,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EBF5FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6c02435b4b9c66a89fd48a35bca42d12.svg";
export { ForwardRef as ReactComponent };